const CLOSE = '@@Tab/Close';
import {reducer as reducerBase} from 'reactis-forms';

export function reducer(state, action) {
	switch (action.type) {
		case CLOSE:
			return state.delete('tab_' + action.id);

		default:
			return reducerBase(state, action);
	}
}


// WEBPACK FOOTER //
// ./src/redux/modules/formTab.js